import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _assignCategoriesRequest = {};
var _assignCategoriesResponse = { challenge: '_challenge' };
var _bulkChallengeResult = { item: '_challenge' };
var _bulkUpdateChallengeRequest = { challenges: '_maskedChallenge' };
var _bulkUpdateChallengeResponse = { results: '_bulkChallengeResult' };
var _certificate = { connectedDate: 'google.protobuf.Timestamp' };
var _challenge = { settings: '_settings', transitions: '_stateTransition' };
var _challengeSection = {
    createdAt: 'google.protobuf.Timestamp',
    updatedAt: 'google.protobuf.Timestamp',
    settings: '_challengeSectionSettings',
    steps: '_challengeStep',
};
var _challengeSectionSettings = { description: '_objectDescription' };
var _challengeStep = {
    createdAt: 'google.protobuf.Timestamp',
    updatedAt: 'google.protobuf.Timestamp',
    settings: '_challengeStepSettings',
};
var _challengeStepSettings = { general: '_generalSettings' };
var _choice = { description: '_objectDescription' };
var _createChallengeRequest = { settings: '_settings' };
var _createChallengeResponse = { challenge: '_challenge' };
var _createSectionRequest = { settings: '_challengeSectionSettings' };
var _createSectionResponse = { section: '_challengeSection' };
var _createStepRequest = { settings: '_challengeStepSettings' };
var _createStepResponse = { step: '_challengeStep' };
var _deleteChallengeRequest = {};
var _deleteChallengeResponse = {};
var _deleteSectionRequest = {};
var _deleteSectionResponse = {};
var _deleteStepRequest = {};
var _deleteStepResponse = {};
var _document = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    thumbnail: '_image',
};
var _feedbackItemSettings = { type: '_feedbackItemType' };
var _feedbackItemType = {
    multipleChoice: '_multipleChoiceFeedbackItem',
    quantity: '_quantityFeedbackItem',
    multiSelect: '_multipleChoiceFeedbackItem',
};
var _focalPoint = { x: 'DOUBLE', y: 'DOUBLE' };
var _generalSettings = {
    individual: '_individualSettings',
    video: '_videoStepSettings',
    description: '_objectDescription',
};
var _getChallengeRequest = {};
var _getChallengeResponse = { challenge: '_challenge' };
var _getInvitationLinkRequest = {};
var _getInvitationLinkResponse = {};
var _getSectionRequest = {};
var _getSectionResponse = { section: '_challengeSection' };
var _getStepRequest = {};
var _getStepResponse = { step: '_challengeStep' };
var _hasCouponsRequest = {};
var _hasCouponsResponse = {};
var _image = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    focalPoint: '_focalPoint',
};
var _individualSettings = {
    feedbackSettings: '_feedbackItemSettings',
    quizSettings: '_feedbackItemSettings',
};
var _listChallengesRequest = {};
var _listChallengesResponse = { memberChallenges: '_memberChallenge' };
var _listSampleChallengesRequest = {};
var _listSampleChallengesResponse = { challenges: '_challenge' };
var _listSectionsRequest = {};
var _listSectionsResponse = { sections: '_challengeSection' };
var _listStepsRequest = {};
var _listStepsResponse = { steps: '_challengeStep' };
var _maskedChallenge = {
    mask: 'google.protobuf.FieldMask',
    challenge: '_challenge',
};
var _mediaItem = { image: '_image', video: '_video', document: '_document' };
var _memberChallenge = { challenge: '_challenge' };
var _migrateQuizzesRequest = {};
var _migrateQuizzesResponse = { steps: '_challengeStep' };
var _moveSectionRequest = {};
var _moveSectionResponse = { section: '_challengeSection' };
var _moveStepRequest = {};
var _moveStepResponse = { steps: '_challengeStep' };
var _multipleChoiceFeedbackItem = { choices: '_choice' };
var _objectDescription = { media: '_mediaItem' };
var _quantityFeedbackItem = { amount: 'DOUBLE' };
var _resolveProgramSlugRequest = {};
var _resolveProgramSlugResponse = {};
var _reward = { certificate: '_certificate' };
var _settings = {
    description: '_objectDescription',
    rewards: '_reward',
    videoStepsSettings: '_videoStepsSettings',
};
var _stateTransition = { occurredAt: 'google.protobuf.Timestamp' };
var _updateChallengeRequest = { settings: '_settings' };
var _updateChallengeResponse = { challenge: '_challenge' };
var _updateSectionRequest = { settings: '_challengeSectionSettings' };
var _updateSectionResponse = { section: '_challengeSection' };
var _updateStepRequest = { settings: '_challengeStepSettings' };
var _updateStepResponse = { step: '_challengeStep' };
var _video = { thumbnail: '_image' };
var _videoResolution = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    poster: '_image',
};
var _videoStepSettings = {
    requiredCompletionPercentage: 'DOUBLE',
    video: '_videoV2',
    coverImage: '_image',
};
var _videoStepsSettings = { requiredCompletionPercentage: 'DOUBLE' };
var _videoV2 = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    resolutions: '_videoResolution',
    posters: '_image',
};
function resolveComWixpressAchievementsApiV1ChallengesServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/challenge-service-web/api/v1/challenges',
                destPath: '/api/v1/challenges',
            },
            {
                srcPath: '/_api/challenge-service-web/api/v1/sample-challenges',
                destPath: '/api/v1/sample-challenges',
            },
            {
                srcPath: '/api/v1/sample-challenges',
                destPath: '/api/v1/sample-challenges',
            },
        ],
        _: [
            {
                srcPath: '/_api/challenge-service-web/api/v1/challenges',
                destPath: '/api/v1/challenges',
            },
            {
                srcPath: '/challenges/api/v1/challenges',
                destPath: '/api/v1/challenges',
            },
            {
                srcPath: '/api/v1/hasCoupons',
                destPath: '/api/v1/hasCoupons',
            },
            {
                srcPath: '/_api/challenge-service-web/api/v1/hasCoupons',
                destPath: '/api/v1/hasCoupons',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/challenge-service-web/api/v1/challenges',
                destPath: '/api/v1/challenges',
            },
        ],
        'challenges.wixapps.net': [
            {
                srcPath: '/challenge-service-web/api/v1/challenges',
                destPath: '/api/v1/challenges',
            },
            {
                srcPath: '/api/v1/challenges',
                destPath: '/api/v1/challenges',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/challenge-service-web/api/v1/challenges',
                destPath: '/api/v1/challenges',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/challenge-service-web/api/v1/challenges',
                destPath: '/api/v1/challenges',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/challenge-service-web/api/v1/challenges',
                destPath: '/api/v1/challenges',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/challenge-service-web/api/v1/challenges',
                destPath: '/api/v1/challenges',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/challenge-service-web/api/v1/challenges',
                destPath: '/api/v1/challenges',
            },
            {
                srcPath: '/challenge-service-web/api/v1/challenges',
                destPath: '/api/v1/challenges',
            },
            {
                srcPath: '/api/v1/hasCoupons',
                destPath: '/api/v1/hasCoupons',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/challenge-service-web/api/v1/challenges',
                destPath: '/api/v1/challenges',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/challenges-proxy',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function listChallenges(payload) {
    var _a = serializer(_listChallengesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listChallengesResponse, {
        _certificate: _certificate,
        _challenge: _challenge,
        _document: _document,
        _focalPoint: _focalPoint,
        _image: _image,
        _mediaItem: _mediaItem,
        _memberChallenge: _memberChallenge,
        _objectDescription: _objectDescription,
        _reward: _reward,
        _settings: _settings,
        _stateTransition: _stateTransition,
        _video: _video,
        _videoStepsSettings: _videoStepsSettings,
    }).fromJSON;
    function __listChallenges(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.challenge',
            method: 'GET',
            methodFqn: 'com.wixpress.achievements.api.v1.ChallengesService.ListChallenges',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAchievementsApiV1ChallengesServiceUrl({
                protoPath: '/api/v1/challenges',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listChallenges.fromReq = fromReq;
    __listChallenges.__isAmbassador = true;
    return __listChallenges;
}
export function createChallenge(payload) {
    var _a = serializer(_createChallengeRequest, {
        _certificate: _certificate,
        _document: _document,
        _focalPoint: _focalPoint,
        _image: _image,
        _mediaItem: _mediaItem,
        _objectDescription: _objectDescription,
        _reward: _reward,
        _settings: _settings,
        _video: _video,
        _videoStepsSettings: _videoStepsSettings,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createChallengeResponse, {
        _certificate: _certificate,
        _challenge: _challenge,
        _document: _document,
        _focalPoint: _focalPoint,
        _image: _image,
        _mediaItem: _mediaItem,
        _objectDescription: _objectDescription,
        _reward: _reward,
        _settings: _settings,
        _stateTransition: _stateTransition,
        _video: _video,
        _videoStepsSettings: _videoStepsSettings,
    }).fromJSON;
    function __createChallenge(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.challenge',
            method: 'POST',
            methodFqn: 'com.wixpress.achievements.api.v1.ChallengesService.CreateChallenge',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAchievementsApiV1ChallengesServiceUrl({
                protoPath: '/api/v1/challenges',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createChallenge.fromReq = fromReq;
    __createChallenge.__isAmbassador = true;
    return __createChallenge;
}
export function getChallenge(payload) {
    var _a = serializer(_getChallengeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getChallengeResponse, {
        _certificate: _certificate,
        _challenge: _challenge,
        _document: _document,
        _focalPoint: _focalPoint,
        _image: _image,
        _mediaItem: _mediaItem,
        _objectDescription: _objectDescription,
        _reward: _reward,
        _settings: _settings,
        _stateTransition: _stateTransition,
        _video: _video,
        _videoStepsSettings: _videoStepsSettings,
    }).fromJSON;
    function __getChallenge(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.challenge',
            method: 'GET',
            methodFqn: 'com.wixpress.achievements.api.v1.ChallengesService.GetChallenge',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAchievementsApiV1ChallengesServiceUrl({
                protoPath: '/api/v1/challenges/{challengeId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getChallenge.fromReq = fromReq;
    __getChallenge.__isAmbassador = true;
    return __getChallenge;
}
export function updateChallenge(payload) {
    var _a = serializer(_updateChallengeRequest, {
        _certificate: _certificate,
        _document: _document,
        _focalPoint: _focalPoint,
        _image: _image,
        _mediaItem: _mediaItem,
        _objectDescription: _objectDescription,
        _reward: _reward,
        _settings: _settings,
        _video: _video,
        _videoStepsSettings: _videoStepsSettings,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateChallengeResponse, {
        _certificate: _certificate,
        _challenge: _challenge,
        _document: _document,
        _focalPoint: _focalPoint,
        _image: _image,
        _mediaItem: _mediaItem,
        _objectDescription: _objectDescription,
        _reward: _reward,
        _settings: _settings,
        _stateTransition: _stateTransition,
        _video: _video,
        _videoStepsSettings: _videoStepsSettings,
    }).fromJSON;
    function __updateChallenge(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.challenge',
            method: 'PATCH',
            methodFqn: 'com.wixpress.achievements.api.v1.ChallengesService.UpdateChallenge',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAchievementsApiV1ChallengesServiceUrl({
                protoPath: '/api/v1/challenges/{challengeId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateChallenge.fromReq = fromReq;
    __updateChallenge.__isAmbassador = true;
    return __updateChallenge;
}
/** Bulk challenge partial update */
export function bulkUpdateChallenge(payload) {
    var _a = serializer(_bulkUpdateChallengeRequest, {
        _certificate: _certificate,
        _challenge: _challenge,
        _document: _document,
        _focalPoint: _focalPoint,
        _image: _image,
        _maskedChallenge: _maskedChallenge,
        _mediaItem: _mediaItem,
        _objectDescription: _objectDescription,
        _reward: _reward,
        _settings: _settings,
        _stateTransition: _stateTransition,
        _video: _video,
        _videoStepsSettings: _videoStepsSettings,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateChallengeResponse, {
        _bulkChallengeResult: _bulkChallengeResult,
        _certificate: _certificate,
        _challenge: _challenge,
        _document: _document,
        _focalPoint: _focalPoint,
        _image: _image,
        _mediaItem: _mediaItem,
        _objectDescription: _objectDescription,
        _reward: _reward,
        _settings: _settings,
        _stateTransition: _stateTransition,
        _video: _video,
        _videoStepsSettings: _videoStepsSettings,
    }).fromJSON;
    function __bulkUpdateChallenge(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.challenge',
            method: 'POST',
            methodFqn: 'com.wixpress.achievements.api.v1.ChallengesService.BulkUpdateChallenge',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAchievementsApiV1ChallengesServiceUrl({
                protoPath: '/api/v1/bulk/challenges/update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateChallenge.fromReq = fromReq;
    __bulkUpdateChallenge.__isAmbassador = true;
    return __bulkUpdateChallenge;
}
export function deleteChallenge(payload) {
    var _a = serializer(_deleteChallengeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteChallengeResponse, {}).fromJSON;
    function __deleteChallenge(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.challenge',
            method: 'DELETE',
            methodFqn: 'com.wixpress.achievements.api.v1.ChallengesService.DeleteChallenge',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAchievementsApiV1ChallengesServiceUrl({
                protoPath: '/api/v1/challenges/{challengeId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteChallenge.fromReq = fromReq;
    __deleteChallenge.__isAmbassador = true;
    return __deleteChallenge;
}
export function listSteps(payload) {
    var _a = serializer(_listStepsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listStepsResponse, {
        _challengeStep: _challengeStep,
        _challengeStepSettings: _challengeStepSettings,
        _choice: _choice,
        _document: _document,
        _feedbackItemSettings: _feedbackItemSettings,
        _feedbackItemType: _feedbackItemType,
        _focalPoint: _focalPoint,
        _generalSettings: _generalSettings,
        _image: _image,
        _individualSettings: _individualSettings,
        _mediaItem: _mediaItem,
        _multipleChoiceFeedbackItem: _multipleChoiceFeedbackItem,
        _objectDescription: _objectDescription,
        _quantityFeedbackItem: _quantityFeedbackItem,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoStepSettings: _videoStepSettings,
        _videoV2: _videoV2,
    }).fromJSON;
    function __listSteps(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.challenge',
            method: 'GET',
            methodFqn: 'com.wixpress.achievements.api.v1.ChallengesService.ListSteps',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAchievementsApiV1ChallengesServiceUrl({
                protoPath: '/api/v1/challenges/{challengeId}/steps',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listSteps.fromReq = fromReq;
    __listSteps.__isAmbassador = true;
    return __listSteps;
}
export function createStep(payload) {
    var _a = serializer(_createStepRequest, {
        _challengeStepSettings: _challengeStepSettings,
        _choice: _choice,
        _document: _document,
        _feedbackItemSettings: _feedbackItemSettings,
        _feedbackItemType: _feedbackItemType,
        _focalPoint: _focalPoint,
        _generalSettings: _generalSettings,
        _image: _image,
        _individualSettings: _individualSettings,
        _mediaItem: _mediaItem,
        _multipleChoiceFeedbackItem: _multipleChoiceFeedbackItem,
        _objectDescription: _objectDescription,
        _quantityFeedbackItem: _quantityFeedbackItem,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoStepSettings: _videoStepSettings,
        _videoV2: _videoV2,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createStepResponse, {
        _challengeStep: _challengeStep,
        _challengeStepSettings: _challengeStepSettings,
        _choice: _choice,
        _document: _document,
        _feedbackItemSettings: _feedbackItemSettings,
        _feedbackItemType: _feedbackItemType,
        _focalPoint: _focalPoint,
        _generalSettings: _generalSettings,
        _image: _image,
        _individualSettings: _individualSettings,
        _mediaItem: _mediaItem,
        _multipleChoiceFeedbackItem: _multipleChoiceFeedbackItem,
        _objectDescription: _objectDescription,
        _quantityFeedbackItem: _quantityFeedbackItem,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoStepSettings: _videoStepSettings,
        _videoV2: _videoV2,
    }).fromJSON;
    function __createStep(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.challenge',
            method: 'POST',
            methodFqn: 'com.wixpress.achievements.api.v1.ChallengesService.CreateStep',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAchievementsApiV1ChallengesServiceUrl({
                protoPath: '/api/v1/challenges/{challengeId}/steps',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createStep.fromReq = fromReq;
    __createStep.__isAmbassador = true;
    return __createStep;
}
export function getStep(payload) {
    var _a = serializer(_getStepRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getStepResponse, {
        _challengeStep: _challengeStep,
        _challengeStepSettings: _challengeStepSettings,
        _choice: _choice,
        _document: _document,
        _feedbackItemSettings: _feedbackItemSettings,
        _feedbackItemType: _feedbackItemType,
        _focalPoint: _focalPoint,
        _generalSettings: _generalSettings,
        _image: _image,
        _individualSettings: _individualSettings,
        _mediaItem: _mediaItem,
        _multipleChoiceFeedbackItem: _multipleChoiceFeedbackItem,
        _objectDescription: _objectDescription,
        _quantityFeedbackItem: _quantityFeedbackItem,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoStepSettings: _videoStepSettings,
        _videoV2: _videoV2,
    }).fromJSON;
    function __getStep(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.challenge',
            method: 'GET',
            methodFqn: 'com.wixpress.achievements.api.v1.ChallengesService.GetStep',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAchievementsApiV1ChallengesServiceUrl({
                protoPath: '/api/v1/challenges/{challengeId}/steps/{stepId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getStep.fromReq = fromReq;
    __getStep.__isAmbassador = true;
    return __getStep;
}
export function updateStep(payload) {
    var _a = serializer(_updateStepRequest, {
        _challengeStepSettings: _challengeStepSettings,
        _choice: _choice,
        _document: _document,
        _feedbackItemSettings: _feedbackItemSettings,
        _feedbackItemType: _feedbackItemType,
        _focalPoint: _focalPoint,
        _generalSettings: _generalSettings,
        _image: _image,
        _individualSettings: _individualSettings,
        _mediaItem: _mediaItem,
        _multipleChoiceFeedbackItem: _multipleChoiceFeedbackItem,
        _objectDescription: _objectDescription,
        _quantityFeedbackItem: _quantityFeedbackItem,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoStepSettings: _videoStepSettings,
        _videoV2: _videoV2,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateStepResponse, {
        _challengeStep: _challengeStep,
        _challengeStepSettings: _challengeStepSettings,
        _choice: _choice,
        _document: _document,
        _feedbackItemSettings: _feedbackItemSettings,
        _feedbackItemType: _feedbackItemType,
        _focalPoint: _focalPoint,
        _generalSettings: _generalSettings,
        _image: _image,
        _individualSettings: _individualSettings,
        _mediaItem: _mediaItem,
        _multipleChoiceFeedbackItem: _multipleChoiceFeedbackItem,
        _objectDescription: _objectDescription,
        _quantityFeedbackItem: _quantityFeedbackItem,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoStepSettings: _videoStepSettings,
        _videoV2: _videoV2,
    }).fromJSON;
    function __updateStep(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.challenge',
            method: 'PATCH',
            methodFqn: 'com.wixpress.achievements.api.v1.ChallengesService.UpdateStep',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAchievementsApiV1ChallengesServiceUrl({
                protoPath: '/api/v1/challenges/{challengeId}/steps/{stepId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateStep.fromReq = fromReq;
    __updateStep.__isAmbassador = true;
    return __updateStep;
}
export function moveStep(payload) {
    var _a = serializer(_moveStepRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_moveStepResponse, {
        _challengeStep: _challengeStep,
        _challengeStepSettings: _challengeStepSettings,
        _choice: _choice,
        _document: _document,
        _feedbackItemSettings: _feedbackItemSettings,
        _feedbackItemType: _feedbackItemType,
        _focalPoint: _focalPoint,
        _generalSettings: _generalSettings,
        _image: _image,
        _individualSettings: _individualSettings,
        _mediaItem: _mediaItem,
        _multipleChoiceFeedbackItem: _multipleChoiceFeedbackItem,
        _objectDescription: _objectDescription,
        _quantityFeedbackItem: _quantityFeedbackItem,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoStepSettings: _videoStepSettings,
        _videoV2: _videoV2,
    }).fromJSON;
    function __moveStep(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.challenge',
            method: 'POST',
            methodFqn: 'com.wixpress.achievements.api.v1.ChallengesService.MoveStep',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAchievementsApiV1ChallengesServiceUrl({
                protoPath: '/api/v1/challenges/{challengeId}/steps/{stepId}/move',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __moveStep.fromReq = fromReq;
    __moveStep.__isAmbassador = true;
    return __moveStep;
}
export function deleteStep(payload) {
    var _a = serializer(_deleteStepRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteStepResponse, {}).fromJSON;
    function __deleteStep(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.challenge',
            method: 'DELETE',
            methodFqn: 'com.wixpress.achievements.api.v1.ChallengesService.DeleteStep',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAchievementsApiV1ChallengesServiceUrl({
                protoPath: '/api/v1/challenges/{challengeId}/steps/{stepId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteStep.fromReq = fromReq;
    __deleteStep.__isAmbassador = true;
    return __deleteStep;
}
export function getInvitationLink(payload) {
    var _a = serializer(_getInvitationLinkRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getInvitationLinkResponse, {}).fromJSON;
    function __getInvitationLink(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.challenge',
            method: 'GET',
            methodFqn: 'com.wixpress.achievements.api.v1.ChallengesService.GetInvitationLink',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAchievementsApiV1ChallengesServiceUrl({
                protoPath: '/api/v1/challenges/{challengeId}/invitation-link',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getInvitationLink.fromReq = fromReq;
    __getInvitationLink.__isAmbassador = true;
    return __getInvitationLink;
}
export function listSampleChallenges(payload) {
    var _a = serializer(_listSampleChallengesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listSampleChallengesResponse, {
        _certificate: _certificate,
        _challenge: _challenge,
        _document: _document,
        _focalPoint: _focalPoint,
        _image: _image,
        _mediaItem: _mediaItem,
        _objectDescription: _objectDescription,
        _reward: _reward,
        _settings: _settings,
        _stateTransition: _stateTransition,
        _video: _video,
        _videoStepsSettings: _videoStepsSettings,
    }).fromJSON;
    function __listSampleChallenges(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.challenge',
            method: 'GET',
            methodFqn: 'com.wixpress.achievements.api.v1.ChallengesService.ListSampleChallenges',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAchievementsApiV1ChallengesServiceUrl({
                protoPath: '/api/v1/sample-challenges',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listSampleChallenges.fromReq = fromReq;
    __listSampleChallenges.__isAmbassador = true;
    return __listSampleChallenges;
}
export function migrateQuizzes(payload) {
    var _a = serializer(_migrateQuizzesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_migrateQuizzesResponse, {
        _challengeStep: _challengeStep,
        _challengeStepSettings: _challengeStepSettings,
        _choice: _choice,
        _document: _document,
        _feedbackItemSettings: _feedbackItemSettings,
        _feedbackItemType: _feedbackItemType,
        _focalPoint: _focalPoint,
        _generalSettings: _generalSettings,
        _image: _image,
        _individualSettings: _individualSettings,
        _mediaItem: _mediaItem,
        _multipleChoiceFeedbackItem: _multipleChoiceFeedbackItem,
        _objectDescription: _objectDescription,
        _quantityFeedbackItem: _quantityFeedbackItem,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoStepSettings: _videoStepSettings,
        _videoV2: _videoV2,
    }).fromJSON;
    function __migrateQuizzes(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.challenge',
            method: 'POST',
            methodFqn: 'com.wixpress.achievements.api.v1.ChallengesService.MigrateQuizzes',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAchievementsApiV1ChallengesServiceUrl({
                protoPath: '/api/v1/challenges/{challengeId}/migrate-quizzes',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __migrateQuizzes.fromReq = fromReq;
    __migrateQuizzes.__isAmbassador = true;
    return __migrateQuizzes;
}
export function resolveProgramSlug(payload) {
    var _a = serializer(_resolveProgramSlugRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_resolveProgramSlugResponse, {}).fromJSON;
    function __resolveProgramSlug(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.challenge',
            method: 'POST',
            methodFqn: 'com.wixpress.achievements.api.v1.ChallengesService.ResolveProgramSlug',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAchievementsApiV1ChallengesServiceUrl({
                protoPath: '/api/v1/challenges/resolve-slug',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __resolveProgramSlug.fromReq = fromReq;
    __resolveProgramSlug.__isAmbassador = true;
    return __resolveProgramSlug;
}
/** -------------------------------------------------- Sections ----------------------------------------------------- */
export function listSections(payload) {
    var _a = serializer(_listSectionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listSectionsResponse, {
        _challengeSection: _challengeSection,
        _challengeSectionSettings: _challengeSectionSettings,
        _challengeStep: _challengeStep,
        _challengeStepSettings: _challengeStepSettings,
        _choice: _choice,
        _document: _document,
        _feedbackItemSettings: _feedbackItemSettings,
        _feedbackItemType: _feedbackItemType,
        _focalPoint: _focalPoint,
        _generalSettings: _generalSettings,
        _image: _image,
        _individualSettings: _individualSettings,
        _mediaItem: _mediaItem,
        _multipleChoiceFeedbackItem: _multipleChoiceFeedbackItem,
        _objectDescription: _objectDescription,
        _quantityFeedbackItem: _quantityFeedbackItem,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoStepSettings: _videoStepSettings,
        _videoV2: _videoV2,
    }).fromJSON;
    function __listSections(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.challenge',
            method: 'GET',
            methodFqn: 'com.wixpress.achievements.api.v1.ChallengesService.ListSections',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAchievementsApiV1ChallengesServiceUrl({
                protoPath: '/api/v1/challenges/{challengeId}/sections',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listSections.fromReq = fromReq;
    __listSections.__isAmbassador = true;
    return __listSections;
}
export function createSection(payload) {
    var _a = serializer(_createSectionRequest, {
        _challengeSectionSettings: _challengeSectionSettings,
        _document: _document,
        _focalPoint: _focalPoint,
        _image: _image,
        _mediaItem: _mediaItem,
        _objectDescription: _objectDescription,
        _video: _video,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createSectionResponse, {
        _challengeSection: _challengeSection,
        _challengeSectionSettings: _challengeSectionSettings,
        _challengeStep: _challengeStep,
        _challengeStepSettings: _challengeStepSettings,
        _choice: _choice,
        _document: _document,
        _feedbackItemSettings: _feedbackItemSettings,
        _feedbackItemType: _feedbackItemType,
        _focalPoint: _focalPoint,
        _generalSettings: _generalSettings,
        _image: _image,
        _individualSettings: _individualSettings,
        _mediaItem: _mediaItem,
        _multipleChoiceFeedbackItem: _multipleChoiceFeedbackItem,
        _objectDescription: _objectDescription,
        _quantityFeedbackItem: _quantityFeedbackItem,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoStepSettings: _videoStepSettings,
        _videoV2: _videoV2,
    }).fromJSON;
    function __createSection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.challenge',
            method: 'POST',
            methodFqn: 'com.wixpress.achievements.api.v1.ChallengesService.CreateSection',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAchievementsApiV1ChallengesServiceUrl({
                protoPath: '/api/v1/challenges/{challengeId}/sections',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createSection.fromReq = fromReq;
    __createSection.__isAmbassador = true;
    return __createSection;
}
export function getSection(payload) {
    var _a = serializer(_getSectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSectionResponse, {
        _challengeSection: _challengeSection,
        _challengeSectionSettings: _challengeSectionSettings,
        _challengeStep: _challengeStep,
        _challengeStepSettings: _challengeStepSettings,
        _choice: _choice,
        _document: _document,
        _feedbackItemSettings: _feedbackItemSettings,
        _feedbackItemType: _feedbackItemType,
        _focalPoint: _focalPoint,
        _generalSettings: _generalSettings,
        _image: _image,
        _individualSettings: _individualSettings,
        _mediaItem: _mediaItem,
        _multipleChoiceFeedbackItem: _multipleChoiceFeedbackItem,
        _objectDescription: _objectDescription,
        _quantityFeedbackItem: _quantityFeedbackItem,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoStepSettings: _videoStepSettings,
        _videoV2: _videoV2,
    }).fromJSON;
    function __getSection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.challenge',
            method: 'GET',
            methodFqn: 'com.wixpress.achievements.api.v1.ChallengesService.GetSection',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAchievementsApiV1ChallengesServiceUrl({
                protoPath: '/api/v1/challenges/{challengeId}/sections/{sectionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSection.fromReq = fromReq;
    __getSection.__isAmbassador = true;
    return __getSection;
}
export function updateSection(payload) {
    var _a = serializer(_updateSectionRequest, {
        _challengeSectionSettings: _challengeSectionSettings,
        _document: _document,
        _focalPoint: _focalPoint,
        _image: _image,
        _mediaItem: _mediaItem,
        _objectDescription: _objectDescription,
        _video: _video,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateSectionResponse, {
        _challengeSection: _challengeSection,
        _challengeSectionSettings: _challengeSectionSettings,
        _challengeStep: _challengeStep,
        _challengeStepSettings: _challengeStepSettings,
        _choice: _choice,
        _document: _document,
        _feedbackItemSettings: _feedbackItemSettings,
        _feedbackItemType: _feedbackItemType,
        _focalPoint: _focalPoint,
        _generalSettings: _generalSettings,
        _image: _image,
        _individualSettings: _individualSettings,
        _mediaItem: _mediaItem,
        _multipleChoiceFeedbackItem: _multipleChoiceFeedbackItem,
        _objectDescription: _objectDescription,
        _quantityFeedbackItem: _quantityFeedbackItem,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoStepSettings: _videoStepSettings,
        _videoV2: _videoV2,
    }).fromJSON;
    function __updateSection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.challenge',
            method: 'PATCH',
            methodFqn: 'com.wixpress.achievements.api.v1.ChallengesService.UpdateSection',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAchievementsApiV1ChallengesServiceUrl({
                protoPath: '/api/v1/challenges/{challengeId}/sections/{sectionId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateSection.fromReq = fromReq;
    __updateSection.__isAmbassador = true;
    return __updateSection;
}
export function moveSection(payload) {
    var _a = serializer(_moveSectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_moveSectionResponse, {
        _challengeSection: _challengeSection,
        _challengeSectionSettings: _challengeSectionSettings,
        _challengeStep: _challengeStep,
        _challengeStepSettings: _challengeStepSettings,
        _choice: _choice,
        _document: _document,
        _feedbackItemSettings: _feedbackItemSettings,
        _feedbackItemType: _feedbackItemType,
        _focalPoint: _focalPoint,
        _generalSettings: _generalSettings,
        _image: _image,
        _individualSettings: _individualSettings,
        _mediaItem: _mediaItem,
        _multipleChoiceFeedbackItem: _multipleChoiceFeedbackItem,
        _objectDescription: _objectDescription,
        _quantityFeedbackItem: _quantityFeedbackItem,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoStepSettings: _videoStepSettings,
        _videoV2: _videoV2,
    }).fromJSON;
    function __moveSection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.challenge',
            method: 'POST',
            methodFqn: 'com.wixpress.achievements.api.v1.ChallengesService.MoveSection',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAchievementsApiV1ChallengesServiceUrl({
                protoPath: '/api/v1/challenges/{challengeId}/sections/{sectionId}/move',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __moveSection.fromReq = fromReq;
    __moveSection.__isAmbassador = true;
    return __moveSection;
}
export function deleteSection(payload) {
    var _a = serializer(_deleteSectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteSectionResponse, {}).fromJSON;
    function __deleteSection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.challenge',
            method: 'DELETE',
            methodFqn: 'com.wixpress.achievements.api.v1.ChallengesService.DeleteSection',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAchievementsApiV1ChallengesServiceUrl({
                protoPath: '/api/v1/challenges/{challengeId}/sections/{sectionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteSection.fromReq = fromReq;
    __deleteSection.__isAmbassador = true;
    return __deleteSection;
}
export function assignCategories(payload) {
    var _a = serializer(_assignCategoriesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_assignCategoriesResponse, {
        _certificate: _certificate,
        _challenge: _challenge,
        _document: _document,
        _focalPoint: _focalPoint,
        _image: _image,
        _mediaItem: _mediaItem,
        _objectDescription: _objectDescription,
        _reward: _reward,
        _settings: _settings,
        _stateTransition: _stateTransition,
        _video: _video,
        _videoStepsSettings: _videoStepsSettings,
    }).fromJSON;
    function __assignCategories(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.challenge',
            method: 'POST',
            methodFqn: 'com.wixpress.achievements.api.v1.ChallengesService.AssignCategories',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAchievementsApiV1ChallengesServiceUrl({
                protoPath: '/api/v1/challenges/{challengeId}/assign-categories',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __assignCategories.fromReq = fromReq;
    __assignCategories.__isAmbassador = true;
    return __assignCategories;
}
export function hasCoupons(payload) {
    var _a = serializer(_hasCouponsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_hasCouponsResponse, {}).fromJSON;
    function __hasCoupons(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.challenge',
            method: 'POST',
            methodFqn: 'com.wixpress.achievements.api.v1.ChallengesService.HasCoupons',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAchievementsApiV1ChallengesServiceUrl({
                protoPath: '/api/v1/hasCoupons',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __hasCoupons.fromReq = fromReq;
    __hasCoupons.__isAmbassador = true;
    return __hasCoupons;
}
//# sourceMappingURL=http.impl.js.map